import React from 'react'

const SvgComponent = props => (
  <svg viewBox='0 0 62.44 87.32' {...props}>
    <defs />
    <g id='Layer_2' data-name='Layer 2'>
      <g id='general_content' data-name='general content'>
        <path
          className='cls-1'
          d='M31.2 87.32a4.42 4.42 0 0 1-3.5-1.69C26.56 84.22 0 50.64 0 31.22a31.22 31.22 0 0 1 62.44 0c0 19.36-26.56 53-27.7 54.41a4.57 4.57 0 0 1-3.54 1.69zm0-83.38a27.34 27.34 0 0 0-27.3 27.3c0 14.45 17.57 40.3 26.86 52a.58.58 0 0 0 .88 0c9.29-11.67 26.86-37.56 26.86-52a27.34 27.34 0 0 0-27.3-27.3z'
        />
        <path
          className='cls-1'
          d='M31.2 45.61a14.39 14.39 0 1 1 14.39-14.39A14.39 14.39 0 0 1 31.2 45.61zm0-25.83a11.44 11.44 0 1 0 11.44 11.44A11.45 11.45 0 0 0 31.2 19.78z'
        />
      </g>
    </g>
  </svg>
)

export default SvgComponent



// WEBPACK FOOTER //
// ./src/components/UI/Icons/LocationIcon.js